import {areFiltersDifferent, hasRouteChanged} from 'helpers/common'
import store from 'redux/config'
import {RescheduleJobsAC} from 'redux/jobs/rescheduleJobs.duck'
import {RouterStates} from 'router/states/routerStates.enum'
import {TransitionHookType} from 'commonTypes'
import {fetchFilterOptions, JobsGridSessionAC} from 'redux/jobs/gridSession.duck'
import {fetchJobs} from 'redux/jobs/jobs.duck'
import defaultJobsState from 'redux/jobs/state'
import {select_gridSession} from 'redux/jobs/selectors'

const {dispatch} = store

export const getJobsHook: TransitionHookType = {
  criteria: {
    to: state => state?.name === RouterStates.jobs,
  },
  callback: transition => {
    const {pagination, sorting, filters} = transition.params()

    const gridSession = select_gridSession(store.getState())

    const hasPageSizeChanged = pagination.pageSize !== gridSession.pagination.pageSize
    const haveFiltersChanged = areFiltersDifferent(filters, gridSession.filters)

    const resetPageIndex = hasPageSizeChanged || haveFiltersChanged
    const defaultPageIndex = defaultJobsState.gridSession.pagination.pageIndex

    dispatch(JobsGridSessionAC.paginationApplied({
      pageIndex: resetPageIndex ? defaultPageIndex : pagination.pageIndex,
      pageSize: pagination.pageSize,
    }))

    if (resetPageIndex || hasRouteChanged(transition)) {
      dispatch(JobsGridSessionAC.cursorReset())
      dispatch(JobsGridSessionAC.paginationDirectionReset())
    }

    dispatch(JobsGridSessionAC.sortingApplied(sorting))

    const shouldUsePrevStateValue = (filters.searchQuery === '' && filters.jobType.length === 0 && filters.jobType.length === 0 && filters.jobStatus.length === 0) && (gridSession.filters.searchQuery !== '' || gridSession.filters.databaseId.length > 0 || gridSession.filters.jobType.length > 0 || gridSession.filters.jobStatus.length > 0)
    shouldUsePrevStateValue ? dispatch(JobsGridSessionAC.filtersApplied(gridSession.filters)) : dispatch(JobsGridSessionAC.filtersApplied(filters))

    dispatch(RescheduleJobsAC.rescheduleJobsReset())
    dispatch(fetchFilterOptions())
    dispatch(fetchJobs())
  },
}
